export enum NoticeType {
  Contract = "CONTRACT",
  ContractAward = "CONTRACT_AWARD",
  ExAnteTransparenz = "EX_ANTE_TRANSPARENZ",
  PriorInformation = "PRIOR_INFORMATION",
  PriorInformationShortenTimeLimits = "PRIOR_INFORMATION_SHORTEN_TIME_LIMITS",
}
